import { useLayoutEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import { RowLabelTooltipProps } from './RowLabelTooltip.props';
import { classes, Root } from './RowLabelTooltip.styles';

const CustomTooltip = Tooltip;

const RowLabelTooltip = ({ title, containerWidth, children }: RowLabelTooltipProps) => {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [titleWidth, setTitleWidth] = useState<number>(0);

  const hasEllipsis = titleWidth - 1 >= containerWidth;

  useLayoutEffect(() => {
    if (ref.current) {
      setTitleWidth(ref.current.offsetWidth);
    }
  }, [title]);

  return (
    <Root id="row-title" className={classes.title}>
      <span ref={ref}>
        {hasEllipsis ? (
          <CustomTooltip
            title={typeof title === 'string' ? title : ''}
            placement="bottom-start"
            slotProps={{
              tooltip: {
                sx: {
                  marginTop: '0 !important',
                },
              },
            }}>
            {children}
          </CustomTooltip>
        ) : (
          children
        )}
      </span>
    </Root>
  );
};

export default RowLabelTooltip;
